import React, { useEffect, useState, useRef } from 'react';
import { collection, onSnapshot, doc, setDoc, deleteDoc, query, where, getDocs, getDoc } from 'firebase/firestore';
import { firestore } from './../../FirebaseUtils';
import QuestionCard from './QuestionCard';
import { Alert, Button, Table } from 'react-bootstrap';
import AdminUserAnswers from './AdminUserAnswers';

function AdminUsersAnswers() {

    const [ loading, setLoading ] = useState();
    const [ errorMessage, setErrorMessage ] = useState();

    const [ employeeId, setEmployeeId ] = useState();
    const [ answers, setAnswers ] = useState([]);
    const [ employeeData, setEmployeeData ] = useState();

    const employeeIdRef = useRef();

    async function getData(e) {
        setLoading(true);
        setErrorMessage(null);

        const employeeId = employeeIdRef.current.value.trim();

        setEmployeeId(employeeId);

        try {
            const q = query(collection(firestore, "usersAnswers"), where("employeeId", "==", employeeId));
            const querySnapshot = await getDocs(q);
        
            const employeeAnswers = [];
            querySnapshot.forEach((doc) => {
                employeeAnswers.push({ id: doc.id, ...doc.data() });
            });

            setAnswers(employeeAnswers);
        
            console.log("Employee Answers:", employeeAnswers);
        
            // Now you have an array of documents with employeeId "800800"
            // You can iterate through employeeAnswers and access the data
        }
        catch (error) {
            console.error("Error getting documents:", error);

            setErrorMessage(error);
            setLoading(false);
            return;
        }

        await getEmployeeData(employeeId);

        setLoading(false);
    }

    async function getEmployeeData(eid) {
        try {
            const docRef = doc(firestore, "employees", eid);
            const docSnap = await getDoc(docRef);
        
            if (docSnap.exists()) {
                console.log("Document data:", docSnap.data());
                // Access the data using docSnap.data()
                // For example:
                const employeeName = docSnap.data().name;
                console.log("Employee Name:", employeeName);

                setEmployeeData(docSnap.data());
            } else {
                console.log("No such document!");
            }
        }
        catch (error) {
            console.error("Error getting document:", error);

            setErrorMessage(error);
        }
    };

    return (
        <div>
            <div>รหัสพนักงาน <input type="text" ref={employeeIdRef} readOnly={loading} /> <Button onClick={getData} disabled={loading} >Search</Button> </div>
            
            { /* Note that I don't do search by employee name because different people can have the same name */}

            { loading ? <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', color: 'blue' }}>Loading ...</div> : null }
            { errorMessage ? <Alert variant='danger'>{errorMessage}</Alert> : null }

            {
                employeeId && answers && employeeData ?
                    <div>
                    {
                        answers.sort((a1, a2) => a2.timestamp.localeCompare(a1.timestamp)).map((data, i) => {
                            return (
                                <div className='mt-5'><AdminUserAnswers key={i} data={data} employeeData={employeeData} /></div>
                            );
                        })
                    }
                    </div>
                :
                    null
            }
        </div>
    );
}

export default AdminUsersAnswers;
